<template>
  <div class="acc-notif-item margin-top-m">
    <div class="large margin-bottom-xs">
      {{ INBOX.rewardsLabel }}
    </div>
    <p class="margin-bottom-s">
      {{ rewardsDowngradeInfo }}
    </p>
    <div class="margin-bottom-m">
      <NotificationsButton :page-url="INBOX.enrollRewards.rewardsPageUrl" :button-label="INBOX.enrollRewards.viewButtonLabel">
        {{ INBOX.viewButtonLabel }}
      </NotificationsButton>
    </div>
  </div>
</template>
<script setup>
import { INBOX } from 'config';
import NotificationsButton from './NotificationsButton';

defineProps({
  rewardsDowngradeInfo: {
    type: String,
    default: '',
  },
});
</script>
